<div class="top-0 left-0 full-width flex row x-content-center y-items-center z-index-300 global-spinner" [ngClass]="[fullCover ? 'fixed vh-100 opacity-box-dark' : 'absolute full-height opacity-box-white']">
  <div>
    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [diameter]="diameter" [strokeWidth]="strokeWidth" [value]="value"></mat-progress-spinner>
  </div>
</div>
<div class="top-0 left-0 full-width flex row x-content-center y-items-center z-index-300 global-spinner" [ngClass]="[fullCover ? 'fixed vh-100 opacity-box-dark' : 'absolute full-height opacity-box-white']">
  <div style=" margin-top: 9%; ">
    <div class="demo-section" style=" margin-top: 27px; ">
      <button mat-button disabled>
      {{'LOGIN.PLACEHOLDER.PROGRESS' | translate}} {{value}}%
      </button>
    </div>
  </div>
</div>
